var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Menu'),_c('MenuMovil'),_c('CoreView'),_c('FooterPerfil'),_c('PerfilOpciones')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }